export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-secondary-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 font-heading text-lg font-bold text-white mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-white rounded-md text-sm font-bold">
                国
              </span>
              <span>国产传媒</span>
            </Link>
            <p className="text-sm leading-relaxed text-secondary-400">
              专注本土内容创作与传播的核心平台，汇聚优质国产影视、资讯、娱乐内容，助力品牌与创作者实现高效传播。
            </p>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/films-tv" className="text-sm text-secondary-400 hover:text-white transition-colors">影视剧集</Link></li>
              <li><Link to="/category/news-info" className="text-sm text-secondary-400 hover:text-white transition-colors">新闻资讯</Link></li>
              <li><Link to="/category/entertainment" className="text-sm text-secondary-400 hover:text-white transition-colors">娱乐综艺</Link></li>
              <li><Link to="/category/tech-digital" className="text-sm text-secondary-400 hover:text-white transition-colors">科技数码</Link></li>
              <li><Link to="/category/culture-art" className="text-sm text-secondary-400 hover:text-white transition-colors">文化艺术</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">服务与合作</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-secondary-400 hover:text-white transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-400 hover:text-white transition-colors">广告投放</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-400 hover:text-white transition-colors">内容合作</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-400 hover:text-white transition-colors">创作者入驻</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-400 hover:text-white transition-colors">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-secondary-400">
                <i className="ri-mail-line text-base"></i>
                <span>contact@guochuanmedia.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-secondary-400">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-secondary-400">
                <i className="ri-map-pin-line text-base"></i>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-500">
            &copy; {currentYear} 国产传媒 版权所有 | 京ICP备2025000001号 | 京公网安备11010502000001号
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-secondary-500 hover:text-secondary-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-secondary-500 hover:text-secondary-300 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-secondary-500 hover:text-secondary-300 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}